// import { Routes, Route, Navigate } from "react-router-dom";
// import Login from "../pages/auth/Login";
// import AuthLayout from "../layouts/AuthLayout";
// import SuperAdminLayout from "../layouts/SuperAdminLayout";
// import ProtectedRoute from "./ProtectedRoute";
// import SuperAdminDashboard from "../pages/super-admin/Dashboard";
// import HospitalDetails from  "../pages/super-admin/HospitalDetails"
// import ROLES from "../utils/constants";

// const AppRoutes = () => {
//   return (
//     <Routes>
//       {/* ✅ Default route */}
//       <Route path="/" element={<Navigate to="/login" replace />} />

//       <Route element={<AuthLayout />}>
//         <Route path="/login" element={<Login />} />
//       </Route>

//       <Route
//         path="/super-admin"
//         element={
//           <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN]}>
//             <SuperAdminLayout />
//           </ProtectedRoute>
//         }
//       >
//         <Route path="dashboard" element={<SuperAdminDashboard />} />
//       </Route>

//       <Route
//         path="/super-admin/hospitals/:id"
//         element={<HospitalDetails />}
//       />

//       {/* Optional: catch-all */}
//       <Route path="*" element={<Navigate to="/login" replace />} />
//     </Routes>
//   );
// };

// export default AppRoutes;

import { Routes, Route, Navigate } from "react-router-dom";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ResetPassword from "../pages/auth/ResetPassword";
import ChangePassword from "../pages/auth/ChangePassword";
import AuthLayout from "../layouts/AuthLayout";
import SuperAdminLayout from "../layouts/SuperAdminLayout";
import ProtectedRoute from "./ProtectedRoute";
import SuperAdminDashboard from "../pages/super-admin/Dashboard";
import HospitalList from "../pages/super-admin/HospitalList";
import HospitalForm from "../pages/super-admin/HospitalForm";
import HospitalDetails from "../pages/super-admin/HospitalDetails";
import DoctorList from "../pages/super-admin/DoctorList";
import DoctorForm from "../pages/super-admin/DoctorForm";
import AuditLogList from "../pages/super-admin/AuditLogList";
import { AdminSubscriptionPage, SubscriptionListingPage, SubscriptionDashboard } from "../pages/super-admin";
import HospitalSubscriptionPage from "../pages/hospital/HospitalSubscriptionPage";
import ROLES from "../utils/constants";
import RegisterHospital from "../pages/auth/RegisterHospital";
import TenantDashboard from "../pages/tenant/Dashboard";
import LegalDocumentViewer from "../pages/tenant/LegalDocumentViewer";
import LegalAcceptanceHistory from "../pages/tenant/LegalAcceptanceHistory";
import DashboardRedirect from "./DashboardRedirect";
import MDTTemplateList from "../pages/super-admin/MDTTemplateList";
import SubscriptionForm from "../pages/super-admin/SubscriptionForm";
import LegalContentList from "../pages/super-admin/LegalContentList";
import LegalDocumentEditor from "../pages/super-admin/LegalDocumentEditor";
import Profile from "../pages/Profile";
import NotificationsPage from "../pages/NotificationsPage";


const AppRoutes = () => {
  return (
    <Routes>
      {/* Default */}
      <Route path="/" element={<Navigate to="/login" replace />} />

      {/* Auth */}
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<Login />} />
        <Route path="/admin/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/register" element={<RegisterHospital />} />
        <Route path="/subscription" element={<HospitalSubscriptionPage />} />
      </Route>

      {/* ✅ SUPER ADMIN AREA */}
      <Route
        path="/"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN]}>
            <SuperAdminLayout />
          </ProtectedRoute>
        }
      >
        <Route path="dashboard" element={<SuperAdminDashboard />} />
        <Route path="profile" element={<Profile />} />
        <Route path="notifications" element={<NotificationsPage />} />
        <Route path="hospitals" element={<HospitalList />} />
        <Route path="hospitals/new" element={<HospitalForm />} />
        <Route path="hospitals/:id" element={<HospitalDetails />} />
        <Route path="hospitals/:id/edit" element={<HospitalForm />} />
        <Route path="doctors" element={<DoctorList />} />
        <Route path="doctors/new" element={<DoctorForm />} />
        <Route path="doctors/:userId/edit" element={<DoctorForm />} />
        <Route path="mdt-templates" element={<MDTTemplateList />} />
        <Route path="audit-logs" element={<AuditLogList />} />
        <Route path="legal-content" element={<LegalContentList />} />
        <Route path="legal-content/edit" element={<LegalDocumentEditor />} />
        <Route path="super-admin/subscription" element={<AdminSubscriptionPage />} />
        <Route path="super-admin/subscription/new" element={<SubscriptionForm />} />
        <Route path="super-admin/subscription/:id/edit" element={<SubscriptionForm />} />
        <Route path="super-admin/subscriptions" element={<SubscriptionListingPage />} />
        <Route path="super-admin/subscriptions/dashboard" element={<SubscriptionDashboard />} />
        <Route path="super-admin/subscription-dashboard" element={<SubscriptionDashboard />} />
        <Route path="super-admin/subscription-listing" element={<SubscriptionListingPage />} />
      </Route>

      {/* ✅ TENANT ADMIN AREA */}
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.DOCTOR, ROLES.HOSPITAL_USER]}>
            <TenantDashboard />
          </ProtectedRoute>
        }
      />

      <Route
        path="/admin/profile"
        element={
          <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.DOCTOR, ROLES.HOSPITAL_USER]}>
            <Profile />
          </ProtectedRoute>
        }
      />

      {/* Direct notifications fallback */}
      <Route
        path="/notifications"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.DOCTOR, ROLES.HOSPITAL_USER]}>
            <SuperAdminLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<NotificationsPage />} />
      </Route>

      {/* Direct profile fallback */}
      <Route
        path="/profile"
        element={
          <ProtectedRoute allowedRoles={[ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.DOCTOR, ROLES.HOSPITAL_USER]}>
            <Profile />
          </ProtectedRoute>
        }
      />

      {/* ✅ USER LEGAL DOCUMENT VIEWER (normal users, published only) */}
      <Route
        path="/admin/legal"
        element={
          <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.DOCTOR, ROLES.HOSPITAL_USER]}>
            <LegalDocumentViewer />
          </ProtectedRoute>
        }
      />

      {/* ✅ USER LEGAL ACCEPTANCE HISTORY (own records only, read-only) */}
      <Route
        path="/admin/legal/history"
        element={
          <ProtectedRoute allowedRoles={[ROLES.ADMIN, ROLES.TENANT_ADMIN, ROLES.DOCTOR, ROLES.HOSPITAL_USER]}>
            <LegalAcceptanceHistory />
          </ProtectedRoute>
        }
      />

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

export default AppRoutes;


